import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

/**
 * The VimeoUrlPipe can be used to modify the video URL to match the needs of the embedded Vimeo video player.
 */
@Pipe({
  name: 'vimeoUrl'
})
export class VimeoUrlPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {
  }

  transform(value: any, ...args: any[]): any {
    if (value && this.isNeedToTransform(value)) {
      const url: string = value.replace('vimeo.com/', 'player.vimeo.com/video/');
      const urlParts: string[] = url.split('/');
      return this.sanitizer.bypassSecurityTrustResourceUrl(urlParts.slice(0, 5).join('/'));
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  isNeedToTransform(value: any, ...args: any[]): boolean {
    return !value.includes('player.vimeo.com/video');
  }
}
